import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
  IAPI_STA008_Request,
  IAPI_STA008_Response,
  IAPI_BUS009_Request,
  IAPI_BUS009_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 退職者詳細情報更新
const httpAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });

  return res.data;
};

// 退職時の育休出勤日数の登録・整合性チェック
// 業務チェック
const httpAPI_BUS009 = async (
  param: IAPI_BUS009_Request
): Promise<IAPI_BUS009_Response> => {
  let res = await http.post(ApiUrl.API_BUS009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA003, httpAPI_STA008, httpAPI_BUS009 };
